import "./TechTips.css";

export default function ProperlyLoadMotorcycle() {
  return (
    <div className="tech-tips-container">
      <h2>Tech Tips for your Harley-Davidson</h2>
      <h3>How to Properly Load your Harley-Davidson</h3>

      <section>
        <h4>General Precautions</h4>
        <ol>
          <li>
            Always follow the safety warnings associated with the equipment you
            are loading or unloading and follow the manufacturer’s operating
            instructions.
          </li>
          <li>
            When loading/unloading equipment, always remember that you are on an
            incline. There is potential for flipping over. Be extremely careful.
          </li>
          <li>
            Always have a person watching as you load or unload your vehicle.
          </li>
          <li>
            For every inch of height you are loading/unloading, your ramp should
            be 2.2 inches long; For example: to load a motorcycle into a 30 inch
            truck bed height you should have a ramp at least 66 inches long.
            (30” x 2.2” = 66” Ramp Length Needed). If not sure always go longer.
          </li>
          <li>DO NOT alter ramp in any way.</li>
          <li>
            We do not recommend riding your motorcycle up the motorcycle loading
            ramp.
            <br />
            You and your spotter should roll the motorcycle up with the engine
            turned OFF. Be on guard for “Tip-Over’s.”
          </li>
        </ol>
      </section>

      <section>
        <h4>Placement of Ramps</h4>
        <ol>
          <li>Fit loading ramp firmly against tailgate, rubber fingers up.</li>
          <li>
            Depress lever on safety strap buckle and pull hook assembly from
            ramp to extend length of strap. Loop this strap around a cross bar
            and attach at a point 8" to 12" from the top of where equipment
            wheels will ride on the loading ramp. Attach hook securely
            underneath vehicle or trailer to the metal portion of the bumper or
            frame. The Safety Strap assembly is designed to keep the ramp from
            sliding off the end of your truck, tailgate, or trailer. It is not
            designed to prevent a loading ramp from free falling to the ground.
            Always be sure that your ramp is set firmly against the tailgate of
            your truck or trailer.
          </li>
          <li>
            Pull the unattached end of the strap so that it is tightly holding
            loading ramp(s) against tailgate or trailer.
          </li>
          <li>
            Before loading/unloading the motorcycle, make sure the ramp does not
            slip back or sideways on tailgate by pulling from the bottom of the
            ramp to ensure the top of the ramp remains in contact with the end
            of the tailgate or trailer.
          </li>
        </ol>
      </section>

      <section>
        <h4>Loading &amp; Unloading</h4>
        <ol>
          <li>Use caution when loading/unloading your motorcycle.</li>
          <li>
            Ensure the weight of your motorcycle does not exceed specified
            weight capacity of the ramp.
          </li>
          <li>
            No additional passengers or cargo should be on the motorcycle while
            loading or unloading. We recommend lightening the bike as much as
            possible, empty saddlebags and touring pack.
          </li>
          <li>
            Have your spotter verify that the tires of your motorcycle are on
            the ramp.
          </li>
          <li>
            Have your spotter guide you up the ramp. Go slow enough to stop in
            case your spotter tells you to stop.
          </li>
          <li>
            We do not recommend running the motorcycle and using the clutch to
            drive your bike up the ramp unless you are experienced in this type
            of operation. If you choose to use the vehicle’s engine do not spin
            the tires or over accelerate as you guide the motorcycle up the
            ramp.
          </li>
          <li>
            When unloading follow the same safety precautions being sure to use
            the brakes to maintain a slow descent.
          </li>
        </ol>
      </section>

      <section>
        <h4>Remember:</h4>
        <ul>
          <li>
            Always wear a helmet when riding any wheeled vehicle. Never operate
            any equipment or use a loading ramp after consuming any alcoholic
            beverage or medication.
          </li>
          <li>
            Never exceed the load capacity of the loading ramp. Never load
            equipment with additional passengers or cargo in and/or on
            equipment. Never use the loading ramp as a ladder.
          </li>
          <li>
            <strong>
              Not following all safety warnings, precautions and instructions
              may result in property damage and/or severe personal injury.
            </strong>
          </li>
        </ul>
      </section>
    </div>
  );
}
